export default {"src":"/_next/static/media/white-kitchen.739fd230.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};